"use client";

import { c as _c } from "react/compiler-runtime";
import { Box, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { OutputPanel } from "#/features/output/ui/OutputPanel";
import { TreeViewPanel } from "#/features/treeViewer/ui/TreeViewPanel";
import { useI18nContext } from "#/shared/hooks";
import { CollapsiblePanel, CollapsiblePanelToggle } from "./CollapsiblePanel";
import { MOBILE_PHASE_NAV_HEIGHT } from "./MobilePhaseNavBar";
export const MobileResultsView: React.FC = () => {
  const $ = _c(30);
  const {
    LL
  } = useI18nContext();
  const [outputCollapsed, setOutputCollapsed] = useState(true);
  const [outputTab, setOutputTab] = useState("1");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      fontWeight: 600
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== LL) {
    t1 = LL.OUTPUT();
    $[1] = LL;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <Typography variant="caption" sx={t0}>{t1}</Typography>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const outputHeader = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setOutputCollapsed(_temp);
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleOutputToggle = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = newValue => {
      setOutputTab(newValue);
      setOutputCollapsed(false);
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleOutputTabChange = t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      display: "flex",
      flexDirection: "column",
      height: "100%",
      overflow: "hidden"
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Box sx={{
      flex: 1,
      minHeight: 0,
      overflow: "hidden"
    }}><TreeViewPanel /></Box>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      mt: 1,
      overflow: "hidden",
      flexShrink: 0
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      alignItems: "center",
      width: "100%",
      minHeight: 52,
      paddingBottom: `calc(${MOBILE_PHASE_NAV_HEIGHT}px + env(safe-area-inset-bottom, 0px))`
    };
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      flex: 1,
      minWidth: 0
    };
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setOutputCollapsed(false);
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== outputTab) {
    t11 = <Box sx={t9}><OutputPanel headerOnly={true} value={outputTab} onTabChange={handleOutputTabChange} onTabBarClick={t10} /></Box>;
    $[13] = outputTab;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <CollapsiblePanelToggle isCollapsed={true} onToggle={handleOutputToggle} aria-label="Expand output" />;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t11) {
    t13 = <Stack direction="row" sx={t8}>{t11}{t12}</Stack>;
    $[16] = t11;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      height: "40vh",
      minHeight: 0,
      overflow: "hidden"
    };
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  const t15 = outputCollapsed ? "Expand output" : "Collapse output";
  let t16;
  if ($[19] !== outputCollapsed || $[20] !== t15) {
    t16 = <CollapsiblePanelToggle isCollapsed={outputCollapsed} onToggle={handleOutputToggle} aria-label={t15} />;
    $[19] = outputCollapsed;
    $[20] = t15;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== outputTab || $[23] !== t16) {
    t17 = <Box sx={t14}><OutputPanel value={outputTab} onTabChange={setOutputTab} trailingHeaderActions={t16} /></Box>;
    $[22] = outputTab;
    $[23] = t16;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== outputCollapsed || $[26] !== outputHeader || $[27] !== t13 || $[28] !== t17) {
    t18 = <Box sx={t5}>{t6}<Box sx={t7}><CollapsiblePanel header={outputHeader} collapsed={outputCollapsed} onToggle={setOutputCollapsed} hideHeaderRow={true} collapsedContent={t13}>{t17}</CollapsiblePanel></Box></Box>;
    $[25] = outputCollapsed;
    $[26] = outputHeader;
    $[27] = t13;
    $[28] = t17;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  return t18;
};
function _temp(state) {
  return !state;
}